// import React, { useState, useEffect, useMemo } from 'react';
// import ReactDOM from 'react-dom';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, PieChart, Pie, Cell, Legend, LineChart, Line } from 'recharts';
// import '../Styles/VendorDashboard.css';

// const VendorDashboard = () => {
//   const [vendorData, setVendorData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [supplierCode, setSupplierCode] = useState('0001000145');
//   const [companyCode, setCompanyCode] = useState('1000');
//   const [tempSupplierCode, setTempSupplierCode] = useState('0001000145');
//   const [tempCompanyCode, setTempCompanyCode] = useState('1000');
//   const [showPOModal, setShowPOModal] = useState(false);
//   const [purchaseOrders, setPurchaseOrders] = useState([]);
//   const [loadingPO, setLoadingPO] = useState(false);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [poDateFilter, setPODateFilter] = useState('all');
//   const [showCustomDates, setShowCustomDates] = useState(false);
//   const [dateWarning, setDateWarning] = useState('');

//   // Handle search button click
//   const handleSearch = () => {
//     setSupplierCode(tempSupplierCode);
//     setCompanyCode(tempCompanyCode);
//   };

//   // Handle Enter key press
//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSearch();
//     }
//   };

//   // Handle date filter change in modal
//   const handlePODateFilterChange = (e) => {
//     const selectedFilter = e.target.value;
//     setPODateFilter(selectedFilter);
//     setDateWarning(''); // Clear warning when filter changes
    
//     if (selectedFilter === 'custom') {
//       setShowCustomDates(true);
//     } else {
//       setShowCustomDates(false);
//       // Clear custom dates when using predefined filters
//       setFromDate('');
//       setToDate('');
//     }
//   };

//   // Fetch purchase orders when PO count is clicked
//   const fetchPurchaseOrders = async () => {
//     try {
//       setLoadingPO(true);
//       setDateWarning(''); // Clear any previous warnings
      
//       // Validate custom date filter
//       if (poDateFilter === 'custom' && (!fromDate || !toDate)) {
//         setDateWarning('Please select both From Date and To Date for custom date range.');
//         setLoadingPO(false);
//         return;
//       }
      
//       // Build URL - only add date_filter if not 'all'
//       let url = `https://dev-agent.savictech.com/ocr/api/vendor-transactions/purchase-orders?supplier_code=${supplierCode}&company_code=${companyCode}`;
      
//       // Add date_filter parameter only if a specific filter is selected
//       if (poDateFilter !== 'all') {
//         url += `&date_filter=${poDateFilter}`;
        
//         // Add custom date parameters if custom filter is selected
//         if (poDateFilter === 'custom' && fromDate && toDate) {
//           // Format dates as DD-MM-YYYY for the API
//           const formatDateForAPI = (dateStr) => {
//             const [year, month, day] = dateStr.split('-');
//             return `${day}-${month}-${year}`;
//           };
//           url += `&from_date=${formatDateForAPI(fromDate)}&to_date=${formatDateForAPI(toDate)}`;
//         }
//       }
      
//       const response = await fetch(url);
      
//       if (!response.ok) {
//         throw new Error('Failed to fetch purchase orders');
//       }
      
//       const data = await response.json();
//       setPurchaseOrders(data);
//       setShowPOModal(true);
//     } catch (err) {
//       console.error('Error fetching purchase orders:', err);
//       alert('Unable to load purchase orders. Please try again.');
//     } finally {
//       setLoadingPO(false);
//     }
//   };

//   // Close modal
//   const closeModal = () => {
//     setShowPOModal(false);
//     setFromDate('');
//     setToDate('');
//     setPODateFilter('all');
//     setShowCustomDates(false);
//     setDateWarning('');
//   };

//   // Fetch vendor data from API
//   useEffect(() => {
//     const fetchVendorData = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         // Fetch data from API
//         const response = await fetch(
//           `https://dev-agent.savictech.com/ocr/api/vendor-transactions/summary?supplier_code=${supplierCode}&company_code=${companyCode}`
//         );
        
//         if (!response.ok) {
//           throw new Error('Failed to fetch vendor data');
//         }
        
//         const data = await response.json();
        
//         if (data && data.length > 0) {
//           setVendorData(data[0]);
//         } else {
//           setError('No data found for the selected filters. Please check your supplier and company codes.');
//           setVendorData(null);
//         }
//       } catch (err) {
//         console.error('Error fetching vendor data:', err);
//         setError('Unable to load vendor data. Please ensure the API is running and try again.');
//         setVendorData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     // Only fetch if both supplier code and company code are provided
//     if (supplierCode && companyCode) {
//       fetchVendorData();
//     }
//   }, [supplierCode, companyCode]);

//   // Reset date filters when supplier or company code changes
//   useEffect(() => {
//     setFromDate('');
//     setToDate('');
//     if (showPOModal) {
//       setShowPOModal(false);
//     }
//   }, [supplierCode, companyCode]);

//   // Calculate derived metrics
//   const calculatedMetrics = useMemo(() => {
//     if (!vendorData) return null;

//     const grFulfillmentRate = vendorData.POQUANTITY > 0 
//       ? ((vendorData.GRQUANTITY / vendorData.POQUANTITY) * 100).toFixed(2)
//       : 0;

//     const irFulfillmentRate = vendorData.GRQUANTITY > 0
//       ? ((vendorData.IRQTY / vendorData.GRQUANTITY) * 100).toFixed(2)
//       : 0;

//     const paymentRate = vendorData.IRAMOUNT > 0
//       ? ((vendorData.PAYMENT / vendorData.IRAMOUNT) * 100).toFixed(2)
//       : 0;

//     const avgPOAmount = vendorData.POCOUNT > 0
//       ? (vendorData.POAMOUNT / vendorData.POCOUNT).toFixed(2)
//       : 0;

//     const avgGRAmount = vendorData.GRCOUNT > 0
//       ? (vendorData.GRAMOUNT / vendorData.GRCOUNT).toFixed(2)
//       : 0;

//     const avgIRAmount = vendorData.IRCOUNT > 0
//       ? (vendorData.IRAMOUNT / vendorData.IRCOUNT).toFixed(2)
//       : 0;

//     const outstandingBalance = vendorData.IRAMOUNT - vendorData.PAYMENT;

//     return {
//       grFulfillmentRate,
//       irFulfillmentRate,
//       paymentRate,
//       avgPOAmount,
//       avgGRAmount,
//       avgIRAmount,
//       outstandingBalance
//     };
//   }, [vendorData]);

//   // Format currency
//   const formatCurrency = (value) => {
//   return new Intl.NumberFormat('en-IN', {
//     style: 'currency',
//     currency: 'INR',
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 0
//   }).format(value);
// };

//   // Format number with commas
  
//   const formatNumber = (value) => {
//   return new Intl.NumberFormat('en-IN').format(value);
// };

//   // Format percentage
//   const formatPercentage = (value) => {
//     return `${value}%`;
//   };

//   // Custom colors for charts
//   const COLORS = ['#4318FF', '#00C9A7', '#FF6B6B', '#FFD93D', '#6BCF7F', '#A78BFA'];

//   if (loading) {
//     return (
//       <div className="vendor-dashboard">
//         <div className="loading-container">
//           <div className="spinner"></div>
//           <p>Loading vendor transaction data...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error && !vendorData) {
//     return (
//       <div className="vendor-dashboard">
//         {/* Header */}
//         <div className="dashboard-header">
//           <div className="header-left">
//             <div className="logo-section">
//               <span className="logo-icon">📊</span>
//               <span className="vendor-login-text">Vendor Dashboard</span>
//             </div>
//           </div>
//           <div className="header-center">
//             <h1 className="dashboard-main-title">Vendor Transaction Summary</h1>
//           </div>
//         </div>

//         {/* Filters Section */}
//         <div className="filters-section">
//           <div className="filter-group">
//             <label htmlFor="supplierCode">Supplier Code</label>
//             <input
//               id="supplierCode"
//               type="text"
//               value={tempSupplierCode}
//               onChange={(e) => setTempSupplierCode(e.target.value)}
//               onKeyPress={handleKeyPress}
//               placeholder="Enter supplier code"
//               className="filter-input"
//             />
//           </div>
//           <div className="filter-group">
//             <label htmlFor="companyCode">Company Code</label>
//             <input
//               id="companyCode"
//               type="text"
//               value={tempCompanyCode}
//               onChange={(e) => setTempCompanyCode(e.target.value)}
//               onKeyPress={handleKeyPress}
//               placeholder="Enter company code"
//               className="filter-input"
//             />
//           </div>
//           <button className="search-btn" onClick={handleSearch}>
//             <span className="search-icon">🔍</span> Search
//           </button>
//         </div>

//         <div className="error-container">
//           <p className="error-message">{error}</p>
//           <button className="retry-btn" onClick={handleSearch}>Try Again</button>
//         </div>
//       </div>
//     );
//   }

//   // Check if vendorData exists before rendering
//   if (!vendorData) {
//     return (
//       <div className="vendor-dashboard">
//         <div className="loading-container">
//           <div className="spinner"></div>
//           <p>Initializing dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   // Prepare chart data for comparison
//   const comparisonData = [
//     {
//       category: 'Purchase Orders',
//       Count: vendorData.POCOUNT,
//       Quantity: vendorData.POQUANTITY,
//       Amount: vendorData.POAMOUNT
//     },
//     {
//       category: 'Goods Receipts',
//       Count: vendorData.GRCOUNT,
//       Quantity: vendorData.GRQUANTITY,
//       Amount: vendorData.GRAMOUNT
//     },
//     {
//       category: 'Invoice Receipts',
//       Count: vendorData.IRCOUNT,
//       Quantity: vendorData.IRQTY,
//       Amount: vendorData.IRAMOUNT
//     }
//   ];

//   // Pie chart data for amount distribution
//   const amountDistributionData = [
//     { name: 'PO Amount', value: vendorData.POAMOUNT },
//     { name: 'IR Amount', value: vendorData.IRAMOUNT },
//     { name: 'Total Payment', value: vendorData.PAYMENT }
//   ];

//   // Process flow data
//   const processFlowData = [
//     { stage: 'Purchase Orders', count: vendorData.POCOUNT, amount: vendorData.POAMOUNT },
//     { stage: 'Goods Receipts', count: vendorData.GRCOUNT, amount: vendorData.GRAMOUNT },
//     { stage: 'Invoice Receipts', count: vendorData.IRCOUNT, amount: vendorData.IRAMOUNT },
//     { stage: 'Payment', count: 1, amount: vendorData.PAYMENT }
//   ];

//   return (
//     <div className="vendor-dashboard">
//       {/* Header */}
//       <div className="dashboard-header">
//         <div className="header-left">
//           <div className="logo-section">

//             <span className="vendor-login-text">Vendor Dashboard</span>
//           </div>
//         </div>
//         <div className="header-center">
//           <h1 className="dashboard-main-title">Vendor Transaction Summary</h1>
//           <p className="dashboard-subtitle">Real-time insights and analytics</p>
//         </div>
//         <div className="header-right">
//           <div className="vendor-info">
//             <span className="info-label">Vendor ID:</span>
//             <span className="info-value">{vendorData.LIFNR}</span>
//           </div>
//           <div className="company-info">
//             <span className="info-label">Company:</span>
//             <span className="info-value">{vendorData.BUKRS}</span>
//           </div>
//         </div>
//       </div>

//       {/* Filters Section */}
//       <div className="filters-section">
//         <div className="filter-group">
//           <label htmlFor="supplierCode">Vendor Code</label>
//           <input
//             id="supplierCode"
//             type="text"
//             value={tempSupplierCode}
//             onChange={(e) => setTempSupplierCode(e.target.value)}
//             onKeyPress={handleKeyPress}
//             placeholder="Enter supplier code"
//             className="filter-input"
//           />
//         </div>
//         <div className="filter-group">
//           <label htmlFor="companyCode">Company Code</label>
//           <input
//             id="companyCode"
//             type="text"
//             value={tempCompanyCode}
//             onChange={(e) => setTempCompanyCode(e.target.value)}
//             onKeyPress={handleKeyPress}
//             placeholder="Enter company code"
//             className="filter-input"
//           />
//         </div>
//         <button className="search-btn" onClick={handleSearch}>
//           Search
//         </button>
//       </div>

//       {/* Loading Overlay */}
//       {loading && (
//         <div className="loading-overlay">
//           <div className="spinner"></div>
//         </div>
//       )}

//       {/* Main Metrics Cards */}
//       {/* Row 1: 4 cards */}
//       <div className={`kpi-cards-grid ${loading ? 'loading-content' : ''}`}>
//         <div className="kpi-card-new primary-card">
//           <div className="kpi-content">
//             <div className="kpi-title-new">Inbound Count</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.INBCOUNT)}</div>
//           </div>
//         </div>

//         <div className="kpi-card-new clickable" onClick={fetchPurchaseOrders}>
//           <div className="kpi-content">
//             <div className="kpi-title-new">Purchase Orders</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.POCOUNT)}</div>
//             <div className="kpi-subtitle">Avg: {formatCurrency(calculatedMetrics.avgPOAmount)}</div>
//             <div className="kpi-link">Click to view details</div>
//           </div>
//         </div>

//         <div className="kpi-card-new">
//           <div className="kpi-content">
//             <div className="kpi-title-new">PO Quantity</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.POQUANTITY)}</div>
//             <div className="kpi-subtitle">Units ordered</div>
//           </div>
//         </div>

//         <div className="kpi-card-new success-card">
//           <div className="kpi-content">
//             <div className="kpi-title-new">PO Amount</div>
//             <div className="kpi-value-new">{formatCurrency(vendorData.POAMOUNT)}</div>
//           </div>
//         </div>
//       </div>

//       {/* Row 2: 2 cards */}
//       <div className="kpi-cards-grid kpi-cards-grid-2">
//         <div className="kpi-card-new">
//           <div className="kpi-content">
//             <div className="kpi-title-new">Goods Receipt</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.GRCOUNT)}</div>
//             <div className="kpi-subtitle">Avg: {formatCurrency(calculatedMetrics.avgGRAmount)}</div>
//           </div>
//         </div>

//         <div className="kpi-card-new">
//           <div className="kpi-content">
//             <div className="kpi-title-new">GR Quantity</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.GRQUANTITY)}</div>
//             <div className="kpi-subtitle">{formatPercentage(calculatedMetrics.grFulfillmentRate)} of PO</div>
//           </div>
//         </div>
//       </div>

//       {/* Row 3: 3 cards */}
//       <div className="kpi-cards-grid kpi-cards-grid-3">
//         <div className="kpi-card-new">
//           <div className="kpi-content">
//             <div className="kpi-title-new">Invoice Receipt</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.IRCOUNT)}</div>
//             <div className="kpi-subtitle">Avg: {formatCurrency(calculatedMetrics.avgIRAmount)}</div>
//           </div>
//         </div>

//         <div className="kpi-card-new">
//           <div className="kpi-content">
//             <div className="kpi-title-new">IR Quantity</div>
//             <div className="kpi-value-new">{formatNumber(vendorData.IRQTY)}</div>
//             <div className="kpi-subtitle">Units invoiced</div>
//           </div>
//         </div>

//         <div className="kpi-card-new success-card">
//           <div className="kpi-content">
//             <div className="kpi-title-new">IR Amount</div>
//             <div className="kpi-value-new">{formatCurrency(vendorData.IRAMOUNT)}</div>
//           </div>
//         </div>
//       </div>

//       {/* Row 4: 1 card */}
//       <div className="kpi-cards-grid kpi-cards-grid-1">
//         <div className="kpi-card-new gradient-green">
//           <div className="kpi-content">
//             <div className="kpi-title-new">Total Payment</div>
//             <div className="kpi-value-new">{formatCurrency(vendorData.PAYMENT)}</div>
//             <div className="kpi-subtitle">✓ Processed</div>
//           </div>
//         </div>
//       </div>

//       {/* Performance Metrics Row */}
//       {/* <div className="performance-metrics">
//         <div className="metric-card-enhanced">
//           <div className="metric-header">
//             <span className="metric-title">GR Fulfillment Rate</span>
//           </div>
//           <div className="metric-value-large">{formatPercentage(calculatedMetrics.grFulfillmentRate)}</div>
//           <div className="metric-description">Of ordered quantity received</div>
//           <div className="progress-bar">
//             <div className="progress-fill" style={{width: `${calculatedMetrics.grFulfillmentRate}%`, background: '#00C9A7'}}></div>
//           </div>
//         </div>

//         <div className="metric-card-enhanced">
//           <div className="metric-header">
//             <span className="metric-title">IR Processing Rate</span>
//           </div>
//           <div className="metric-value-large">{formatPercentage(calculatedMetrics.irFulfillmentRate)}</div>
//           <div className="metric-description">Of received quantity invoiced</div>
//           <div className="progress-bar">
//             <div className="progress-fill" style={{width: `${calculatedMetrics.irFulfillmentRate}%`, background: '#4318FF'}}></div>
//           </div>
//         </div>

//         <div className="metric-card-enhanced">
//           <div className="metric-header">
//             <span className="metric-title">Payment Progress</span>
//           </div>
//           <div className="metric-value-large">{formatPercentage(calculatedMetrics.paymentRate)}</div>
//           <div className="metric-description">Of invoiced amount paid</div>
//           <div className="progress-bar">
//             <div className="progress-fill" style={{width: `${calculatedMetrics.paymentRate}%`, background: '#FFD93D'}}></div>
//           </div>
//         </div>

//         <div className="metric-card-enhanced outstanding">
//           <div className="metric-header">
//             <span className="metric-title">Outstanding Balance</span>
//           </div>
//           <div className="metric-value-large">{formatCurrency(calculatedMetrics.outstandingBalance)}</div>
//           <div className="metric-description">Pending payment amount</div>
//         </div>
//       </div> */}

//       {/* Financial Overview */}
//       {/* <div className="additional-metrics">
//         <div className="metric-card gradient-blue">
//           <div className="metric-details">
//             <div className="metric-title">Invoice Receipt Details</div>
//             <div className="metric-value">{formatNumber(vendorData.IRQTY)} Units</div>
//             <div className="metric-amount">{formatCurrency(vendorData.IRAMOUNT)}</div>
//           </div>
//         </div>
//         <div className="metric-card gradient-green">
//           <div className="metric-details">
//             <div className="metric-title">Total Payment Made</div>
//             <div className="metric-value">{formatCurrency(vendorData.PAYMENT)}</div>
//             <div className="metric-status">✓ Processed</div>
//           </div>
//         </div>
//       </div> */}

//       {/* Comparison Charts */}
//       <div className="charts-row-three">
//         {/* Quantity Comparison */}
//         <div className="chart-card">
//           <div className="chart-header">
//             <h3 className="chart-title">Quantity Flow Analysis</h3>
//             <span className="chart-badge">Units</span>
//           </div>
//           <ResponsiveContainer width="100%" height={200}>
//             <BarChart data={comparisonData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//               <XAxis dataKey="category" tick={{ fontSize: 10, fill: '#4a5568' }} />
//               <YAxis tick={{ fontSize: 10, fill: '#4a5568' }} />
//               <Tooltip 
//                 contentStyle={{ backgroundColor: '#fff', border: '2px solid #00C9A7', borderRadius: '8px' }}
//                 labelStyle={{ fontWeight: 'bold', color: '#2d3748' }}
//               />
//               <Bar dataKey="Quantity" fill="#00C9A7" radius={[8, 8, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>

//         {/* Amount Distribution Bar Chart */}
//         <div className="chart-card">
//           <div className="chart-header">
//             <h3 className="chart-title">Amount Distribution</h3>
//             <span className="chart-badge">Financial</span>
//           </div>
//           <ResponsiveContainer width="100%" height={200}>
//             <BarChart data={amountDistributionData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//               <XAxis dataKey="name" tick={{ fontSize: 10, fill: '#4a5568' }} />
//               <YAxis tick={{ fontSize: 10, fill: '#4a5568' }} />
//               <Tooltip 
//                 contentStyle={{ backgroundColor: '#fff', border: '2px solid #6366F1', borderRadius: '8px' }}
//                 labelStyle={{ fontWeight: 'bold', color: '#2d3748' }}
//                 formatter={(value) => formatCurrency(value)}
//               />
//               <Bar dataKey="value" fill="#6366F1" radius={[8, 8, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       {/* Process Flow Chart */}
//       <div className="chart-card-single">
//         <div className="chart-header">
//           <h3 className="chart-title">End-to-End Process Flow</h3>
//           <span className="chart-badge">Pipeline</span>
//         </div>
//         <ResponsiveContainer width="100%" height={220}>
//           <LineChart data={processFlowData}>
//             <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//             <XAxis dataKey="stage" tick={{ fontSize: 10, fill: '#4a5568' }} />
//             <YAxis yAxisId="left" tick={{ fontSize: 10, fill: '#4a5568' }} />
//             <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 10, fill: '#4a5568' }} />
//             <Tooltip 
//               contentStyle={{ backgroundColor: '#fff', border: '2px solid #4318FF', borderRadius: '8px' }}
//               labelStyle={{ fontWeight: 'bold', color: '#2d3748' }}
//             />
//             <Legend wrapperStyle={{ fontSize: '11px' }} />
//             <Line yAxisId="left" type="monotone" dataKey="count" stroke="#4318FF" strokeWidth={2} dot={{ r: 4 }} name="Count" />
//             <Line yAxisId="right" type="monotone" dataKey="amount" stroke="#00C9A7" strokeWidth={2} dot={{ r: 4 }} name="Amount" />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>

//       {/* Summary Table */}
//       {/* <div className="table-section">
//         <h3 className="table-title">Vendor Summary Details</h3>
//         <div className="table-container">
//           <table className="supplier-table">
//             <thead>
//               <tr>
//                 <th>Vendor ID</th>
//                 <th>Company Code</th>
//                 <th>Inbound Count</th>
//                 <th>PO Count</th>
//                 <th>PO Quantity</th>
//                 <th>PO Amount</th>
//                 <th>GR Count</th>
//                 <th>GR Quantity</th>
//                 <th>GR Amount</th>
//                 <th>IR Count</th>
//                 <th>IR Quantity</th>
//                 <th>IR Amount</th>
//                 <th>Payment</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td className="supplier-name">{vendorData.LIFNR}</td>
//                 <td>{vendorData.BUKRS}</td>
//                 <td>{formatNumber(vendorData.INBCOUNT)}</td>
//                 <td>{formatNumber(vendorData.POCOUNT)}</td>
//                 <td>{formatNumber(vendorData.POQUANTITY)}</td>
//                 <td>{formatCurrency(vendorData.POAMOUNT)}</td>
//                 <td>{formatNumber(vendorData.GRCOUNT)}</td>
//                 <td>{formatNumber(vendorData.GRQUANTITY)}</td>
//                 <td>{formatCurrency(vendorData.GRAMOUNT)}</td>
//                 <td>{formatNumber(vendorData.IRCOUNT)}</td>
//                 <td>{formatNumber(vendorData.IRQTY)}</td>
//                 <td>{formatCurrency(vendorData.IRAMOUNT)}</td>
//                 <td>{formatCurrency(vendorData.PAYMENT)}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div> */}

//       {/* Purchase Orders Modal */}
//       {showPOModal && ReactDOM.createPortal(
//         <div className="modal-overlay" onClick={closeModal}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h2>Purchase Orders Details</h2>
//               <div className="modal-date-filters">
//                 <div className="modal-filter-group">
//                   <label>Date Range:</label>
//                   <select
//                     value={poDateFilter}
//                     onChange={handlePODateFilterChange}
//                     className="modal-date-input"
//                   >
//                     <option value="all">All</option>
//                     <option value="current_month">Current Month</option>
//                     <option value="previous_month">Previous Month</option>
//                     <option value="current_quarter">Current Quarter</option>
//                     <option value="previous_quarter">Previous Quarter</option>
//                     <option value="current_year">Current Year</option>
//                     <option value="custom">Custom</option>
//                   </select>
//                 </div>
//                 {showCustomDates && (
//                   <>
//                     <div className="modal-filter-group">
//                       <label>From Date:</label>
//                       <input 
//                         type="date" 
//                         value={fromDate} 
//                         onChange={(e) => setFromDate(e.target.value)}
//                         className="modal-date-input"
//                       />
//                     </div>
//                     <div className="modal-filter-group">
//                       <label>To Date:</label>
//                       <input 
//                         type="date" 
//                         value={toDate} 
//                         onChange={(e) => setToDate(e.target.value)}
//                         className="modal-date-input"
//                       />
//                     </div>
//                   </>
//                 )}
//                 <button className="modal-filter-btn" onClick={fetchPurchaseOrders}>
//                   Apply Filter
//                 </button>
//               </div>
//               {dateWarning && (
//                 <div className="date-warning-message">
//                   <span className="warning-icon">⚠️</span>
//                   <span className="warning-text">{dateWarning}</span>
//                 </div>
//               )}
//               <button className="modal-close" onClick={closeModal}>×</button>
//             </div>
            
//             {loadingPO ? (
//               <div className="modal-loading">
//                 <div className="spinner"></div>
//                 <p>Loading purchase orders...</p>
//               </div>
//             ) : (
//               <div className="modal-body">
//                 <div className="modal-table-container">
//                   <table className="po-table">
//                     <thead>
//                       <tr>
//                         <th>PO Date</th>
//                         <th>Purchase Order</th>
//                         <th>PO Amount</th>
//                         <th>Invoice Amount</th>
//                         <th>Payment</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {purchaseOrders.map((po, index) => (
//                         <tr key={index}>
//                           <td>{po.PURCHASEORDERDATE}</td>
//                           <td>{po.PURCHASEORDER}</td>
//                           <td>{formatCurrency(po.POAMOUNT)}</td>
//                           <td>{formatCurrency(po.INVAMOUNT)}</td>
//                           <td>{formatCurrency(po.PAYMENT)}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="modal-footer">
//                   <p>Total Records: {purchaseOrders.length}</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>,
//         document.body
//       )}

//     </div>
//   );
// };

// export default VendorDashboard;



import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import '../Styles/VendorDashboard.css';

// ── API endpoints ─────────────────────────────────────────────────────────────
const VIM_DASHBOARD_API = 'https://ocrtool.savictech.com/api/vim/dashboard';
const VIM_JOURNEY_API   = 'https://ocrtool.savictech.com/api/vim/journey/po';
const VIM_INVOICE_API   = 'https://ocrtool.savictech.com/api/vim/invoices';

// ── Status config ────────────────────────────────────────────────────────────
const STATUS_CONFIG = {
  PO_CREATED:     { label: 'PO Created',      color: '#718096', bg: '#f7fafc', border: '#e2e8f0' },
  GR_PARTIAL:     { label: 'GR Partial',       color: '#b7791f', bg: '#fffff0', border: '#fbd38d' },
  GR_COMPLETED:   { label: 'GR Completed',     color: '#2b6cb0', bg: '#ebf8ff', border: '#bee3f8' },
  INVOICE_POSTED: { label: 'Invoice Posted',   color: '#553c9a', bg: '#faf5ff', border: '#d6bcfa' },
  BLOCKED:        { label: 'Blocked',          color: '#c53030', bg: '#fff5f5', border: '#fc8181' },
  APPROVED:       { label: 'Approved',         color: '#276749', bg: '#f0fff4', border: '#9ae6b4' },
  PAID:           { label: 'Paid',             color: '#22543d', bg: '#c6f6d5', border: '#68d391' },
  CANCELLED:      { label: 'Cancelled',        color: '#4a5568', bg: '#edf2f7', border: '#cbd5e0' },
};

// ── Helpers ──────────────────────────────────────────────────────────────────
const formatCurrency = (val, currency) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency', currency: currency || 'INR',
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(val || 0);

const fmtDate = (str) => {
  if (!str) return '—';
  // already formatted like 2024-03-10, just return as-is or pretty-print
  try { return new Date(str).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return str; }
};

// ── StatusBadge ──────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || { label: status, color: '#4a5568', bg: '#edf2f7', border: '#cbd5e0' };
  return (
    <span style={{
      display: 'inline-block', padding: '3px 10px', borderRadius: 12,
      fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
      color: cfg.color, background: cfg.bg, border: `1px solid ${cfg.border}`,
    }}>
      {cfg.label}
    </span>
  );
};

// ── Horizontal Timeline ──────────────────────────────────────────────────────
const Timeline = ({ timeline }) => {
  if (!timeline?.length) return null;
  return (
    <div className="vim-timeline">
      {timeline.map((step, i) => {
        const isDone    = step.completed && !step.active;
        const isCurrent = step.completed && step.active;
        return (
          <React.Fragment key={i}>
            <div className={`vim-step ${isDone ? 'step-done' : isCurrent ? 'step-current' : 'step-future'}`}>
              <div className="vim-step-circle">
                {isDone ? '✓' : isCurrent ? '●' : '○'}
              </div>
              <div className="vim-step-label">{step.label}</div>
              {step.timestamp && <div className="vim-step-date">{fmtDate(step.timestamp)}</div>}
            </div>
            {i < timeline.length - 1 && (
              <div className={`vim-connector ${step.completed ? 'connector-done' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

// ── InfoRow ──────────────────────────────────────────────────────────────────
const InfoRow = ({ label, value, color }) => (
  <div style={{ display: 'flex', flexDirection: 'column', minWidth: 100 }}>
    <span style={{ fontSize: 10, color: '#718096', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.4px' }}>{label}</span>
    <span style={{ fontSize: 13, fontWeight: 600, color: color || '#1a202c', marginTop: 2 }}>{value ?? '—'}</span>
  </div>
);

// ── SectionHeading ───────────────────────────────────────────────────────────
const SectionHeading = ({ children }) => (
  <h4 style={{ margin: '20px 0 10px', fontSize: 13, fontWeight: 600, color: '#2d3748', borderBottom: '1px solid #e2e8f0', paddingBottom: 6 }}>{children}</h4>
);

// ── GRTable (shared) ─────────────────────────────────────────────────────────
const GRTable = ({ rows }) => (
  <div className="modal-table-container">
    <table className="po-table">
      <thead>
        <tr>
          <th>GR Document</th><th>GR Date</th><th>Material</th>
          <th>Plant</th><th style={{ textAlign: 'right' }}>Quantity</th>
          <th style={{ textAlign: 'right' }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((gr, i) => (
          <tr key={i}>
            <td>{gr.material_doc}</td><td>{fmtDate(gr.gr_date)}</td>
            <td>{gr.material}</td><td>{gr.plant}</td>
            <td style={{ textAlign: 'right' }}>{gr.quantity}</td>
            <td style={{ textAlign: 'right' }}>{formatCurrency(gr.amount)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

// ── Main Component ───────────────────────────────────────────────────────────
const VendorDashboard = () => {
  const [vendorCode, setVendorCode]       = useState(localStorage.getItem('vendorCode') || '600000');
  const [inputCode, setInputCode]         = useState(localStorage.getItem('vendorCode') || '600000');

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState(null);
  const [fromDate, setFromDate]           = useState('');
  const [toDate, setToDate]               = useState('');
  const [activeTab, setActiveTab]         = useState('invoices'); // 'invoices' | 'pos'

  // PO Journey modal
  const [poJourney, setPoJourney]       = useState(null);
  const [loadingPO, setLoadingPO]       = useState(false);
  const [showPOModal, setShowPOModal]   = useState(false);

  // Invoice Journey modal
  const [invJourney, setInvJourney]         = useState(null);
  const [loadingInv, setLoadingInv]         = useState(false);
  const [showInvModal, setShowInvModal]     = useState(false);

  // ── Fetch dashboard ────────────────────────────────────────────────────────
  const fetchDashboard = useCallback(async (forceRefresh = false) => {
    if (!vendorCode) {
      setError('Please enter a vendor code.');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      let url = `${VIM_DASHBOARD_API}?vendor_code=${vendorCode}`;
      if (fromDate) url += `&from_date=${fromDate}`;
      if (toDate)   url += `&to_date=${toDate}`;
      if (forceRefresh) url += `&force_refresh=true`;

      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'API returned failure');
      setDashboardData(data);
    } catch (err) {
      setError(err.message || 'Unable to load dashboard');
    } finally {
      setLoading(false);
    }
  }, [vendorCode, fromDate, toDate]);

  // Fetch whenever vendorCode or dates change (vendorCode changes on Search click)
  useEffect(() => { if (vendorCode) fetchDashboard(); }, [vendorCode]); // eslint-disable-line

  // ── Fetch PO Journey ───────────────────────────────────────────────────────
  const fetchPOJourney = async (poNumber) => {
    setPoJourney(null);
    setShowPOModal(true);
    setLoadingPO(true);
    try {
      const res = await fetch(`${VIM_JOURNEY_API}/${poNumber}?vendor_code=${vendorCode}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'API returned failure');
      setPoJourney(data);
    } catch (err) {
      setPoJourney({ _error: err.message });
    } finally {
      setLoadingPO(false);
    }
  };

  // ── Fetch Invoice Journey ──────────────────────────────────────────────────
  const fetchInvJourney = async (invoiceDoc, fiscalYear) => {
    setInvJourney(null);
    setShowInvModal(true);
    setLoadingInv(true);
    try {
      const res = await fetch(`${VIM_INVOICE_API}/${invoiceDoc}/${fiscalYear}?vendor_code=${vendorCode}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'API returned failure');
      setInvJourney(data);
    } catch (err) {
      setInvJourney({ _error: err.message });
    } finally {
      setLoadingInv(false);
    }
  };

  // ── Jump from PO modal → Invoice modal ────────────────────────────────────
  const openInvFromPO = (inv) => {
    setShowPOModal(false);
    fetchInvJourney(inv.invoice_doc, inv.fiscal_year);
  };

  // ── Initial full-page loading state (first fetch only) ────────────────────
  if (loading && !dashboardData && vendorCode) {
    return (
      <div className="vendor-dashboard">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading invoice dashboard…</p>
        </div>
      </div>
    );
  }

  const summary = dashboardData?.summary;

  return (
    <div className="vendor-dashboard">

      {/* ── Header ─────────────────────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="header-left">
          <div className="logo-section">
            <span className="vendor-login-text">Vendor Portal</span>
          </div>
        </div>
        <div className="header-center">
          <h1 className="dashboard-main-title">Invoice Lifecycle Dashboard</h1>
          <p className="dashboard-subtitle">Track your purchase orders &amp; invoices in real time</p>
        </div>
        <div className="header-right">
          <div className="vendor-info">
            <span className="info-label">Vendor Code</span>
            <span className="info-value">{vendorCode || '—'}</span>
          </div>
          {dashboardData?.generated_at && (
            <span className="last-updated-btn">
              Updated {new Date(dashboardData.generated_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
            </span>
          )}
        </div>
      </div>

      {/* ── Filters ────────────────────────────────────────────────────── */}
      <div className="filters-section">
        <div className="filter-group">
          <label>Vendor Code</label>
          <input
            type="text"
            value={inputCode}
            onChange={e => setInputCode(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') { setVendorCode(inputCode); } }}
            placeholder="e.g. 600000"
          />
        </div>
        {/* <div className="filter-group">
          <label>From Date</label>
          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        </div>
        <div className="filter-group">
          <label>To Date</label>
          <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
        </div> */}
        <button className="search-btn" onClick={() => setVendorCode(inputCode)} disabled={loading}>
          {loading ? 'Loading…' : 'Search'}
        </button>
        <button className="search-btn" style={{ background: '#718096' }} onClick={() => fetchDashboard(true)} disabled={loading || !vendorCode}>
          Refresh
        </button>
      </div>

      {/* Loading overlay while re-fetching */}
      {loading && dashboardData && (
        <div className="loading-overlay"><div className="spinner"></div></div>
      )}

      {/* Error banner */}
      {error && (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button className="retry-btn" onClick={() => fetchDashboard()}>Retry</button>
        </div>
      )}

      {/* ── KPI Cards ──────────────────────────────────────────────────── */}
      {summary && (
        <div className="kpi-cards-grid" style={{ paddingTop: 15, gridTemplateColumns: 'repeat(6, 1fr)' }}>
          <div className="kpi-card-new">
            <div className="kpi-content">
              <div className="kpi-title-new">Total POs</div>
              <div className="kpi-value-new">{summary.total_pos}</div>
            </div>
          </div>
          <div className="kpi-card-new">
            <div className="kpi-content">
              <div className="kpi-title-new">Total Invoices</div>
              <div className="kpi-value-new">{summary.total_invoices}</div>
            </div>
          </div>
          <div className="kpi-card-new" style={{ borderColor: summary.blocked_count > 0 ? '#fc8181' : undefined }}>
            <div className="kpi-content">
              <div className="kpi-title-new">Blocked</div>
              <div className="kpi-value-new" style={{ color: summary.blocked_count > 0 ? '#c53030' : '#1a202c' }}>
                {summary.blocked_count}
              </div>
            </div>
          </div>
          <div className="kpi-card-new">
            <div className="kpi-content">
              <div className="kpi-title-new">Paid</div>
              <div className="kpi-value-new" style={{ color: '#22543d' }}>{summary.paid_count}</div>
            </div>
          </div>
          <div className="kpi-card-new">
            <div className="kpi-content">
              <div className="kpi-title-new">Pending</div>
              <div className="kpi-value-new" style={{ color: '#b7791f' }}>{summary.pending_count}</div>
            </div>
          </div>
          <div className="kpi-card-new" style={{ borderColor: summary.overdue_count > 0 ? '#fc8181' : undefined }}>
            <div className="kpi-content">
              <div className="kpi-title-new">Overdue</div>
              <div className="kpi-value-new" style={{ color: summary.overdue_count > 0 ? '#e53e3e' : '#1a202c' }}>
                {summary.overdue_count}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Tabs ───────────────────────────────────────────────────────── */}
      {dashboardData && (
        <div className="vim-tabs">
          <button
            className={`vim-tab-btn${activeTab === 'invoices' ? ' active' : ''}`}
            onClick={() => setActiveTab('invoices')}
          >
            Invoices ({dashboardData.invoices?.length || 0})
          </button>
          <button
            className={`vim-tab-btn${activeTab === 'pos' ? ' active' : ''}`}
            onClick={() => setActiveTab('pos')}
          >
            Purchase Orders ({dashboardData.purchase_orders?.length || 0})
          </button>
        </div>
      )}

      {/* ── Invoices Table ─────────────────────────────────────────────── */}
      {dashboardData && activeTab === 'invoices' && (
        <div className="table-section">
          <div className="table-container">
            <table className="supplier-table">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Invoice Doc</th>
                  <th>PO Number</th>
                  <th>Invoice Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Aging</th>
                  <th style={{ textAlign: 'left' }}>Next Action</th>
                </tr>
              </thead>
              <tbody>
                {dashboardData.invoices?.length ? dashboardData.invoices.map((inv, i) => (
                  <tr key={i} onClick={() => fetchInvJourney(inv.invoice_doc, inv.fiscal_year)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>
                      <span style={{ color: '#4318FF', fontWeight: 700 }}>{inv.invoice_doc}</span>
                      {inv.external_invoice_ref && (
                        <div style={{ fontSize: 10, color: '#718096', fontWeight: 400, marginTop: 2 }}>{inv.external_invoice_ref}</div>
                      )}
                    </td>
                    <td>{inv.po_number}</td>
                    <td>{fmtDate(inv.invoice_date)}</td>
                    <td>{formatCurrency(inv.gross_amount, inv.currency)}</td>
                    <td><StatusBadge status={inv.vim_status} /></td>
                    <td style={{ color: (inv.aging_days || 0) > 30 ? '#e53e3e' : '#4a5568' }}>
                      {inv.aging_days != null ? `${inv.aging_days}d` : '—'}
                    </td>
                    <td style={{ textAlign: 'left', fontSize: 11, color: '#4a5568', maxWidth: 220, whiteSpace: 'normal' }}>
                      {inv.next_action}
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: '#718096' }}>No invoices found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Purchase Orders Table ──────────────────────────────────────── */}
      {dashboardData && activeTab === 'pos' && (
        <div className="table-section">
          <div className="table-container">
            <table className="supplier-table">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>PO Number</th>
                  <th>PO Date</th>
                  <th>Items</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th style={{ textAlign: 'left' }}>Next Action</th>
                </tr>
              </thead>
              <tbody>
                {dashboardData.purchase_orders?.length ? dashboardData.purchase_orders.map((po, i) => (
                  <tr key={i} onClick={() => fetchPOJourney(po.po_number)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left', color: '#4318FF', fontWeight: 700 }}>{po.po_number}</td>
                    <td>{fmtDate(po.po_date)}</td>
                    <td>{po.item_count}</td>
                    <td>{formatCurrency(po.total_amount, po.currency)}</td>
                    <td><StatusBadge status={po.vim_status} /></td>
                    <td style={{ textAlign: 'left', fontSize: 11, color: '#4a5568', maxWidth: 220, whiteSpace: 'normal' }}>
                      {po.next_action}
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#718096' }}>No purchase orders found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── PO Journey Modal ───────────────────────────────────────────── */}
      {showPOModal && ReactDOM.createPortal(
        <div className="modal-overlay" onClick={() => setShowPOModal(false)}>
          <div className="modal-content" style={{ maxWidth: 900 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>PO Journey — {poJourney?.po_number || '…'}</h2>
              <button className="modal-close" onClick={() => setShowPOModal(false)}>×</button>
            </div>

            {loadingPO ? (
              <div className="modal-loading"><div className="spinner"></div><p>Loading…</p></div>
            ) : poJourney?._error ? (
              <div className="modal-body"><p className="error-message">{poJourney._error}</p></div>
            ) : poJourney && (
              <div className="modal-body">
                {/* Summary strip */}
                <div className="vim-info-strip">
                  <InfoRow label="Status" value={<StatusBadge status={poJourney.vim_status} />} />
                  <InfoRow label="Total Amount" value={formatCurrency(poJourney.total_amount, poJourney.currency)} />
                  <InfoRow label="Company" value={poJourney.company_code} />
                  <InfoRow label="PO Date" value={fmtDate(poJourney.po_date)} />
                  {poJourney.block_reason && (
                    <InfoRow label="Block Reason" value={poJourney.block_reason} color="#c53030" />
                  )}
                </div>

                {poJourney.next_action && (
                  <div className="vim-next-action">{poJourney.next_action}</div>
                )}

                <SectionHeading>Process Timeline</SectionHeading>
                <Timeline timeline={poJourney.timeline} />

                {/* Line Items */}
                {poJourney.line_items?.length > 0 && (
                  <>
                    <SectionHeading>Line Items</SectionHeading>
                    <div className="modal-table-container">
                      <table className="po-table">
                        <thead>
                          <tr>
                            <th>Item</th><th>Material</th><th>Description</th>
                            <th style={{ textAlign: 'right' }}>Qty</th><th>Unit</th>
                            <th style={{ textAlign: 'right' }}>Amount</th><th>Delivery Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {poJourney.line_items.map((item, i) => (
                            <tr key={i}>
                              <td>{item.item_number}</td>
                              <td>{item.material}</td>
                              <td>{item.material_description || '—'}</td>
                              <td style={{ textAlign: 'right' }}>{item.order_quantity}</td>
                              <td>{item.unit}</td>
                              <td style={{ textAlign: 'right' }}>{formatCurrency(item.net_amount, item.currency)}</td>
                              <td>{fmtDate(item.delivery_date)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* GR History */}
                {poJourney.gr_history?.length > 0 && (
                  <>
                    <SectionHeading>Goods Receipt History</SectionHeading>
                    <GRTable rows={poJourney.gr_history} />
                  </>
                )}

                {/* Linked Invoices */}
                {poJourney.linked_invoices?.length > 0 && (
                  <>
                    <SectionHeading>Linked Invoices — click a row to view details</SectionHeading>
                    <div className="modal-table-container">
                      <table className="po-table">
                        <thead>
                          <tr>
                            <th>Invoice Doc</th><th>Invoice Date</th>
                            <th style={{ textAlign: 'right' }}>Amount</th>
                            <th>Status</th><th>Aging</th>
                          </tr>
                        </thead>
                        <tbody>
                          {poJourney.linked_invoices.map((inv, i) => (
                            <tr key={i} onClick={() => openInvFromPO(inv)} style={{ cursor: 'pointer' }}>
                              <td style={{ color: '#4318FF', fontWeight: 600 }}>{inv.invoice_doc}</td>
                              <td>{fmtDate(inv.invoice_date)}</td>
                              <td style={{ textAlign: 'right' }}>{formatCurrency(inv.gross_amount, inv.currency)}</td>
                              <td><StatusBadge status={inv.vim_status} /></td>
                              <td>{inv.aging_days != null ? `${inv.aging_days}d` : '—'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="modal-footer">
              <p>PO {poJourney?.po_number} · {poJourney?.company_code}</p>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ── Invoice Journey Modal ──────────────────────────────────────── */}
      {showInvModal && ReactDOM.createPortal(
        <div className="modal-overlay" onClick={() => setShowInvModal(false)}>
          <div className="modal-content" style={{ maxWidth: 900 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Invoice — {invJourney?.invoice_doc || '…'}</h2>
              <button className="modal-close" onClick={() => setShowInvModal(false)}>×</button>
            </div>

            {loadingInv ? (
              <div className="modal-loading"><div className="spinner"></div><p>Loading…</p></div>
            ) : invJourney?._error ? (
              <div className="modal-body"><p className="error-message">{invJourney._error}</p></div>
            ) : invJourney && (
              <div className="modal-body">
                {/* Summary strip */}
                <div className="vim-info-strip">
                  <InfoRow label="Status" value={<StatusBadge status={invJourney.vim_status} />} />
                  <InfoRow label="Gross Amount" value={formatCurrency(invJourney.gross_amount, invJourney.currency)} />
                  {invJourney.tax_amount != null && (
                    <InfoRow label="Tax" value={formatCurrency(invJourney.tax_amount, invJourney.currency)} />
                  )}
                  <InfoRow label="Payment Terms" value={invJourney.payment_terms} />
                  <InfoRow label="Invoice Date" value={fmtDate(invJourney.invoice_date)} />
                  {invJourney.external_invoice_ref && (
                    <InfoRow label="Ref" value={invJourney.external_invoice_ref} />
                  )}
                  {invJourney.block_reason && (
                    <InfoRow label="Block Reason" value={invJourney.block_reason} color="#c53030" />
                  )}
                </div>

                {invJourney.next_action && (
                  <div className="vim-next-action">{invJourney.next_action}</div>
                )}

                {/* Payment info banner */}
                {invJourney.payment_info?.available && (
                  <div className="vim-payment-banner">
                    <div className="vim-payment-label">Payment Received</div>
                    <div className="vim-payment-details">
                      <span><strong>Doc:</strong> {invJourney.payment_info.payment_doc}</span>
                      <span><strong>Date:</strong> {fmtDate(invJourney.payment_info.payment_date)}</span>
                      <span><strong>Amount:</strong> {formatCurrency(invJourney.payment_info.payment_amount, invJourney.payment_info.currency)}</span>
                    </div>
                  </div>
                )}

                <SectionHeading>Process Timeline</SectionHeading>
                <Timeline timeline={invJourney.timeline} />

                {/* Line Items */}
                {invJourney.line_items?.length > 0 && (
                  <>
                    <SectionHeading>Line Items</SectionHeading>
                    <div className="modal-table-container">
                      <table className="po-table">
                        <thead>
                          <tr>
                            <th>Item</th><th>PO Number</th><th>Material</th>
                            <th style={{ textAlign: 'right' }}>Qty</th><th>Unit</th>
                            <th style={{ textAlign: 'right' }}>Amount</th><th>Tax Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invJourney.line_items.map((item, i) => (
                            <tr key={i}>
                              <td>{item.item_number}</td>
                              <td>{item.po_number}</td>
                              <td>{item.material}</td>
                              <td style={{ textAlign: 'right' }}>{item.quantity}</td>
                              <td>{item.unit}</td>
                              <td style={{ textAlign: 'right' }}>{formatCurrency(item.net_amount, item.currency)}</td>
                              <td>{item.tax_code || '—'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* GR History */}
                {invJourney.gr_history?.length > 0 && (
                  <>
                    <SectionHeading>Goods Receipt History</SectionHeading>
                    <GRTable rows={invJourney.gr_history} />
                  </>
                )}
              </div>
            )}

            <div className="modal-footer">
              <p>Invoice {invJourney?.invoice_doc} · FY {invJourney?.fiscal_year}</p>
            </div>
          </div>
        </div>,
        document.body
      )}

    </div>
  );
};

export default VendorDashboard;
